module.exports = __webpack_public_path__ + "static/media/livechatProcess1.29506db1.png";